import { render, staticRenderFns } from "./webinars.vue?vue&type=template&id=381500c8&scoped=true"
import script from "./webinars.vue?vue&type=script&lang=js"
export * from "./webinars.vue?vue&type=script&lang=js"
import style0 from "./webinars.vue?vue&type=style&index=0&id=381500c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381500c8",
  null
  
)

export default component.exports